module.exports = __webpack_public_path__ + "label-better.bc7f9c01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/label-better.svg
// module id = 5RVS
// module chunks = 0